import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction, RelatedProducts } from '~/app/tracking/feld-m-types';
import { CatalogItemType, FeatureOrPackage } from '~/graphql/types';

export type SelectionClickEventParams = {
	eventAction: EventAction;
	eventName: string;
	label: string | null | undefined;
	elementName: string;
	value?: string;
	category?: string;
	elementCurrentStep: number;
	elementTotalSteps: number;
	selected?: boolean;
	item?: FeatureOrPackage | CatalogItemType['trimline'] | CatalogItemType['driveTrain'];
	relatedProducts?: RelatedProducts;
	pos?: string;
};

export class SelectionClickEvent extends BaseEvent {
	constructor({
		label,
		eventName,
		eventAction,
		elementName,
		value,
		category,
		elementCurrentStep,
		elementTotalSteps,
		relatedProducts,
		pos = '',
	}: SelectionClickEventParams) {
		super({
			eventInfo: {
				eventAction,
				eventName: `selections - ${eventName}`,
			},
			attributes: {
				componentName: 'selections',
				label: label || '',
				elementName,
				value: value || '',
				pos,
				relatedElements: [
					{
						elementName: 'selection category',
						elementValue: category || '',
						elementCurrentStep: `${elementCurrentStep}`,
						elementTotalSteps: `${elementTotalSteps}`,
					},
				],
				...(relatedProducts && { relatedProducts }),
			},
		});
	}
}
